import React from 'react';
import { Link } from 'react-router-dom';
import { Users, Briefcase, Calendar, FileText } from 'lucide-react';

const Kadry = () => {
  return (
    <div className="space-y-6">
      {/* Placeholder Content */}
      <div className="bg-white shadow rounded-lg p-6">
        <div className="text-center py-12">
          <Users className="mx-auto h-16 w-16 text-gray-400 mb-4" />
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            Moduł Kadry
          </h2>
          <p className="text-gray-500 mb-8">
            Moduł jest w trakcie rozwoju. Funkcjonalności będą dodawane stopniowo.
          </p>
          
          {/* Placeholder Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
            <Link to="/kadry/pracownicy" className="bg-gray-50 rounded-lg p-4 border border-gray-200 hover:bg-gray-100 hover:border-blue-300 transition-colors cursor-pointer">
              <div className="flex items-center mb-2">
                <Users className="h-5 w-5 text-gray-400 mr-2" />
                <h3 className="text-sm font-medium text-gray-700">Pracownicy</h3>
              </div>
              <p className="text-xs text-gray-500">Dni urlopu, historia</p>
            </Link>
            
            <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
              <div className="flex items-center mb-2">
                <Briefcase className="h-5 w-5 text-gray-400 mr-2" />
                <h3 className="text-sm font-medium text-gray-700">Stanowiska</h3>
              </div>
              <p className="text-xs text-gray-500">Wkrótce dostępne</p>
            </div>
            
            <Link to="/kadry/wnioski" className="bg-gray-50 rounded-lg p-4 border border-gray-200 hover:bg-gray-100 hover:border-blue-300 transition-colors cursor-pointer">
              <div className="flex items-center mb-2">
                <Calendar className="h-5 w-5 text-gray-400 mr-2" />
                <h3 className="text-sm font-medium text-gray-700">Urlopy</h3>
              </div>
              <p className="text-xs text-gray-500">Moje wnioski, do podpisania, podpisane</p>
            </Link>
            
            <Link to="/kadry/dokumenty" className="bg-gray-50 rounded-lg p-4 border border-gray-200 hover:bg-gray-100 hover:border-blue-300 transition-colors cursor-pointer">
              <div className="flex items-center mb-2">
                <FileText className="h-5 w-5 text-gray-400 mr-2" />
                <h3 className="text-sm font-medium text-gray-700">Dokumenty</h3>
              </div>
              <p className="text-xs text-gray-500">Wniosek urlopowy, delegacyjny</p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Kadry;

